import Vue from 'vue'
import {
  Button,
  Container,
  Header,
  Aside,
  Alert,
  Main,
  Menu,
  MenuItem,
  Submenu,
  Form,
  FormItem,
  Input,
  Card,
  Row,
  Col,
  Tree,
  Table,
  TableColumn,
  Select,
  Option,
  Radio,
  RadioGroup,
  Loading,
  Pagination,
  Dialog,
  MessageBox,
  Message,
  PageHeader,
  Tag,
  Cascader,
  DatePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Upload,
  Divider,
  Progress,
  Steps,
  Step,
  Tabs,
  TabPane,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Tooltip,
  Checkbox,
  Image,
  CheckboxGroup,
  Descriptions,
  DescriptionsItem,
  InputNumber,
  Timeline,
  TimelineItem,
  Collapse,
  CollapseItem,
  Switch,
  Empty,
  TimePicker,
  TimeSelect
} from 'element-ui'

Vue.use(TimeSelect)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Alert)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tree)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(PageHeader)
Vue.use(Tag)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Upload)
Vue.use(Divider)
Vue.use(Progress)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tooltip)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Image)
Vue.use(TimelineItem)
Vue.use(Timeline)
Vue.use(Empty)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(InputNumber)
Vue.use(Loading.directive)
Vue.use(Switch)
Vue.use(TimePicker)
Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 }

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
